module.exports = __webpack_public_path__ + "img/IconTriangleDown.0ec5e89a.svg";